import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cdb537c0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=cdb537c0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb537c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdb537c0')) {
      api.createRecord('cdb537c0', component.options)
    } else {
      api.reload('cdb537c0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cdb537c0&scoped=true&", function () {
      api.rerender('cdb537c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/caseHandle/caseReply/index.vue"
export default component.exports